module.exports = __webpack_public_path__ + "img/background_rutsche_w400.7babff07.jpg";